import { CarnivoreUser } from '../_types/user.type'

export const CARNIVORE_100_FLAG = 'carnivore100'

// The Carnivore 33 is Axxess-tier content behind a per-user rollout flag. The
// flag string is still `carnivore100` — the list was renamed, the flag was not. The
// backend enforces the same pair (verifyAxxess + verifyFeatureFlag).
export function hasCarnivore100(user: CarnivoreUser | null | undefined): boolean {
  return !!user?.isAxxess && !!user?.featureFlags?.includes(CARNIVORE_100_FLAG)
}
